import React from 'react';
import AmazonProfitSummaryReport from './AmazonProfitSummaryReport';
import { AMAZON_PROFIT_BY_SKU_SUMMARY } from '../../consts/reports';

const AmazonProfitBySkuSummaryReport = (props) => (
  <AmazonProfitSummaryReport
    {...props}
    reportId={AMAZON_PROFIT_BY_SKU_SUMMARY}
    reportTitle="Amazon Profit By SKU"
    reportType="sku"
  />
);

export default AmazonProfitBySkuSummaryReport;
